// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.

import Rails from "@rails/ujs"
import Turbolinks from "turbolinks"
import * as ActiveStorage from "@rails/activestorage"
import "channels"

Rails.start()
Turbolinks.start()
ActiveStorage.start()

// Uncomment to copy all static images under ../images to the output folder and reference
// them with the image_pack_tag helper in views (e.g <%= image_pack_tag 'rails.png' %>)
// or the `imagePath` JavaScript helper below.
//
// const images = require.context('../images', true)
// const imagePath = (name) => images(name, true)

import 'bootstrap'
import '../stylesheets/application.sass'

require("trix")
require("@rails/actiontext")
require('google-charts')
import { GoogleCharts } from 'google-charts'

document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll("#property_facilities_list input[type=checkbox]").forEach((checkbox) => {
    checkbox.addEventListener('change', (e) => {
      e.target.form.querySelectorAll('input[type=submit]')[0].click();
    });
  });

  document.querySelectorAll("select.select-currency").forEach((select) => {
    select.addEventListener('change', (e) => {
      e.target.closest('td').querySelectorAll('.price-by-currency').forEach((el) => {
        if (el.classList.contains("price-in-" + e.target.value)) {
          el.style.display = 'inline-block';
        } else {
          el.style.display = 'none';
        }
      });
    });
  });

  document.querySelectorAll("select.property-image-name").forEach((select) => {
    select.addEventListener('change', (e) => {
      e.target.nextSibling.click();
    });
  });

  document.querySelectorAll("select.property-position").forEach((select) => {
    select.addEventListener('change', (e) => {
      e.target.parentNode.submit();
    });
  });

  GoogleCharts.load(drawChart);

  function drawChart() {
    if (jdata == undefined) return;
    const data = new google.visualization.DataTable();
    data.addColumn('date', 'Month');
    data.addColumn('number', '最低 (PHP/ペソ): ');
    data.addColumn({type:'string', role: 'tooltip'});
    data.addColumn('number', '最高 (PHP/ペソ): ');
    data.addColumn({type:'string', role: 'tooltip'});
    let d = [];
    jdata.forEach((i) => {
      const date = new Date(i[0]);
      d.push([
        date,
        i[1],
        `${i[1].toLocaleString()} PHP/㎡`,
        i[2],
        `${i[2].toLocaleString()} PHP/㎡`
      ])
    });
    data.addRows(d);

    const options = {
      pointSize: 7,
      legend: 'none',
      vAxis: { title: '平米単価(PHP/ペソ)' },
      language: 'ja',
      axes: {
        x: {
          0: { side: 'top' }
        }
      }
    };

    const chart = new GoogleCharts.api.visualization.LineChart(document.getElementById('property_price_chart'));
    chart.draw(data, options);
  }

  if (document.querySelectorAll('.property-progresses')[0]) {
    const progresses = document.querySelectorAll('.property-progresses .property-progress');
    const width = (38.5 * progresses.length) + 0.5;
    document.querySelectorAll('.property-progresses-inside')[0].style.width = width + 'vw';
    document.querySelectorAll('.property-progresses')[0].scrollLeft = (progresses[0].offsetWidth * 0.5);
  }
})